export const messages = {
  title: 'Реквизиты',
  requisites: {
    company: {
      label: 'Полное наименование',
      value: 'Общество с ограниченной ответственностью «Поле»',
    },
    legalAddress: {
      label: 'Адрес регистрации',
      value: '127006, г Москва, вн.тер.г муниципальный округ Тверской, ул Краснопролетарская, 4, помещ 2/1',
    },
    mailingAddress: {
      label: 'Почтовый адрес',
      value: '127006, г Москва, вн.тер.г муниципальный округ Тверской, ул Краснопролетарская, 4, помещ 2/1',
    },
    phone: {
      label: 'Номер телефона',
      value: '8 (495) 927-53-85',
    },
    email: {
      label: 'Адрес эл. почты',
      value: 'info@poleinvest.ru',
    },
    registrationDate: {
      label: 'Дата регистрации',
      value: '23 декабря 2020 года',
    },
    inn: {
      label: 'ИНН',
      value: '7736332054',
    },
    kpp: {
      label: 'КПП',
      value: '770701001',
    },
    ogrn: {
      label: 'ОГРН',
      value: '1207700491855',
    },
    okpo: {
      label: 'ОКПО',
      value: '23156163',
    },
    okved: {
      label: 'ОКВЭД',
      value: '62.01',
    },
    generalManager: {
      label: 'Генеральный директор',
      value: 'Белов Евгений Александрович',
    },
    chiefAccountant: {
      label: 'Главный бухгалтер',
      value: 'Славина Юлия Викторовна',
    },
    bik: {
      label: 'БИК',
      value: '044525411',
    },
    bank: {
      label: 'Банк',
      value: 'Филиал «Центральный» Банка ВТБ (ПАО) в г. Москве',
    },
    billingAccount: {
      label: 'Расчетный счет',
      value: '40702810704800002063',
    },
    correspondentAccount: {
      label: 'Корреспондентский счет',
      value: '30101810145250000411 в Главном управлении Банка России по Центральному федеральному округу г. Москва',
    },
    workingConditions: {
      label: 'Специальная оценка условий труда',
      link: 'Подробнее',
    },
  },
}
